import { render } from "./DefaultPostRelatedSectionNewsCmp.vue?vue&type=template&id=29d1f0ca"
import script from "./DefaultPostRelatedSectionNewsCmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostRelatedSectionNewsCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__